import { render, staticRenderFns } from "./adress.vue?vue&type=template&id=4a57900c&scoped=true&"
import script from "./adress.vue?vue&type=script&lang=js&"
export * from "./adress.vue?vue&type=script&lang=js&"
import style0 from "./adress.vue?vue&type=style&index=0&id=4a57900c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a57900c",
  null
  
)

export default component.exports